define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Een andere gebruiker registeren",

    'incrowd_stats.num_responders': "{{num}} deskundige professionele gezondheidszorgers",
    'incrowd_stats.num_answers': "{{num}} vragen beantwoord",
    'incrowd_stats.time_to_complete': "{{num}} minuten om gemiddelde enquête in te vullen",

    // INCROWD
    'incrowd.about': "Over",
    'incrowd.contact': "Contact",
    'incrowd.press': "Druk op",
    'incrowd.careers': "Carrières",
    'incrowd.terms': "Voorwaarden",
    'incrowd.t_and_c': "Algemene Voorwaarden",
    'incrowd.faq': "Veelgestelde vragen",
    'incrowd.privacy': "Privacy",
    'incrowd.copyright': "{{year}} InCrowd Inc, Alle rechten voorbehouden",
    'incrowd.blog': "Blog",
    'incrowd.support': "Ondersteuning",
    'incrowd.info.ios': "Wist u dat artsen in het InCrowd-netwerk nu direct vragen kunnen sturen naar hun collega’s. Probeer het nu met behulp van de <InCrowd iOS App>!",
    'incrowd.refer': "Vindt u het leuk om aan onze enquêtes deel te nemen? <Stuur vandaag nog een vriend> door naar ons en u verdient beiden 10 Amerikaanse dollar (of een equivalent hiervan). Zodra uw collega een enquête invult, krijgt deze ook een bonus!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "Micro-enquêtes,",
    'getstarted.encourage.title.two': "massale invloed",
    'getstarted.encourage.subtitle': "Voeg u bij duizenden gekwalificeerde medische professionelen die de ontwikkeling van nieuwe producten en patiëntbehandelingen beïnvloeden via eenvoudig micro-onderzoek. En wij betalen u ook!",
    'getstarted.encourage.redirect_to_solutions': "Bent u geen zorgverlener maar wilt u meer informatie over inCrowd?",
    'getstarted.actions.title': "Bent u een gekwalificeerde medische professioneel?",
    'getstarted.actions.subtitle': "Registreer vandaag en begin geld te verdienen door mee te werken aan op gezondheidszorg gericht micro-onderzoek.",
    'getstarted.button.continue': "Van start gaan",
    'getstarted.referral': "Meld u aan om geld te verdienen met enquêtes, plus uw verwijzingsbonus van %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "We hebben wat gegevens van u nodig om uw account op te zetten.",
    'details.profile_details': "Profielgegevens",
    'details.address_information': "Adresgegevens",
    'details.professional_info': "Beroepsmatige informatie",
    'details.heading.finally': "… en tot slot",
    'details.how_receive_surveys': "Hoe zou u uw enquêtes willen ontvangen?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "De basis",
    'professionchoice.encourage.subtitle': "U ziet uw beroep niet? Laat het ons <hier> weten om te garanderen dat wij u inlichten zodra wij uw beroep hebben toegevoegd.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Wie bent u?",
    'authentication.encourage.subtitle': "InCrowd moet uw identiteit controleren, maar wij zullen uw  persoonlijke informatie nooit aan derde partijen onthullen of doorgeven.",
    'authentication.actions.select_notifications': "Selecteer hoe u de enquêtes van ons wilt ontvangen",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Een ogenblik geduld a.u.b. Wij zijn uw gegevens aan het valideren",
    'validation.please_answer': "Beantwoord de volgende vragen om ons te helpen met het valideren van uw persoonlijke gegevens",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Bevestiging",
    'confirmation.validation_success.subtitle': "Uw registratie is compleet, welkom bij InCrowd! U ontvangt spoedig een bevestiging via e-mail en/of sms. Dank u voor uw registratie!",
    'confirmation.validation_error.title': "Probleem",
    'confirmation.validation_error.subtitle': "Sorry, %{userFirstName}, er is een probleem ontstaan met het valideren van uw persoonlijke gegevens.",
    'confirmation.actions_title': "Hoe gaat het verder?",
    'confirmation.go_to_your_profile': "Ga naar uw profiel",
    'confirmation.validation_success.actions_subtitle': "U zult binnenkort de eerste micro enquêtes van 3 - 5 minuten via e-mail of sms ontvangen. Hebt u de ontvangst van enquêtes via sms nog niet ingesteld? U kunt uw communicatie-instellingen te allen tijde veranderen in uw profiel bij InCrowd.",
    'confirmation.validation_error.actions_subtitle': "U kunt inloggen op uw dashboard, maar u zult geen enquêtes ontvangen tot het probleem met uw registratie is verholpen. <Neem contact op met de ondersteuning> voor meer informatie.",
    'confirmation.referral.info.1': "Binnen %{payoutBusinessDays} werkdagen vanaf de afwerking van een 2e enquête zullen u en de persoon die u heeft verwezen <ieder %{currency}%{referralBonusAmount} ontvangen>. Deze %{currency}%{referralBonusAmount} wordt aan uw beloningsaccount toegevoegd. U kunt te allen tijde inloggen bij uw <profiel> om voorkeuren bij te werken, uw beloningen te bekijken of toegang te krijgen tot open enquêtes waar u voor bent uitgenodigd.",
    'confirmation.referral.info.2': "Nog vragen? <Chat met ons>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Bent u gekwalificeerd?",
    'regftr.markets.accepting': "InCrowd-antwoorden accepteert momenteel:",
    'regftr.peers.title': "Vakgenoten",
    'regftr.peers.subtitle': "Vergelijk uw antwoorden met die van uw vakgenoten en leer van hun bijdrage.",
    'regftr.invites.title': "Uitnodigingen",
    'regftr.invites.subtitle': "Ontvang nieuwe uitnodigingen voor onderzoek via e-mail of op uw telefoon om uw verdiensten te maximaliseren.",
    'regftr.earnings.title': "Verdiensten",
    'regftr.earnings.subtitle': "Beheer en volg de informatie over uw verdiensten en betalingen.",
    'regftr.stats.title': "Statistieken",
    'regftr.stats.subtitle': "U hebt toegang tot een instrumentenbord met al uw onderzoeksinformatie en gebruikergegevens.",

    'contextual_help.sms': "Je zult sms’jes ontvangen van open micro-enquêtes. Via sms zul je sneller aan enquêtes deel kunnen nemen en meer beloningen verdienen. Je informatie wordt privé gehouden en zal alleen worden gebruikt voor uitnodigingen voor enquêtes.",
    'contextual_help.specialty': "Neem alleen specialismen op die verbonden zijn met uw NPI, waarin u beurzen hebt voltooid of onderdelen van de geneeskunde die onder uw primaire specialisme vallen. Als u in de toekomst uw specialismen wilt wijzigen, dan moet u contact opnemen via support@incrowdnow.com.",
    // USER
    'user(s)': "Gebruiker |||| Gebruikers",
    'user.login': "Log in",
    'user.logout': "Log uit",
    'user.register': "Registreer",
    'user.invitations': "Uitnodigingen",
    'user.email': "E-mailadres",
    'user.pass_word': "Wachtwoord",
    'user.mobile': "Mobiel",
    'user.mobile.hint': " Vermeld landcode (+%{phoneCode} voor %{countryName})",
    'user.title': "Aanhef",
    'user.title_with_example': "Aanhef (bv. Dr., Mevr., Dhr.)",
    'user.first_name': "Voornaam",
    'user.last_name': "Achternaam",
    'user.middle_name': "Tweede voornaam",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Een gebruiker",
    'user.anonymous_admin': "Beheerder",
    'user.dashboard': "Dashboard",
    'user.profile': "Profiel",
    'user.profile.picture.upload': "Upload profielfoto",
    'user.profile.picture.change': "Wijzig",
    'user.primary_lang': "Hoofdtaal",
    'user.primary_lang?': "Wat is uw hoofdtaal?",
    'user.survey_langs?': "Welke talen kunt u vloeiend spreken?",
    'user.notify_email': "Melden per e-mail",
    'user.notify_mobile': "Melden per  mobiel",
    'user.contact_support': "Neem contact op met de ondersteuning",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "<Neem contact met ons op>.",
    'user.profession': "Beroep",
    'user.profession?': "Wat is uw beroep?",
    'user.join_now': "Word nu lid",
    'user.welcome_back': "Welkom terug!",
    'user.not_a_member?': "Nog geen lid?",
    'user.accept_terms': "Accepteer algemene voorwaarden ",
    'user.accept_terms.yes': "Ik accepteer de <algemene voorwaarden>",
    'user.remember_me': "Onthoud mij op dit apparaat",
    'user.time_zone': "Tijdzone",
    'user.payment.policy': "Zodra u %{currency}25 aan beloningen bereikt, krijgt u bericht en kunt u één van onze betalingsopties selecteren via uw profiel InCrowd Nog vragen? Neem contact met ons op via het chat-venster hieronder.",
    'user.country.live_work?': "In welk land woont en werkt u?",
    // FORMS
    'form.button.back': "Terug",
    'form.button.next': "Verder",
    'form.button.cancel': "Annuleren",
    'form.button.submit': "Indienen",
    'form.button.continue': "Doorgaan",
    'form.button.close': "Sluiten",
    'form.button.go!': "Starten!",
    'form.button.complete!': "Nu voltooien!",
    'form.button.update': "Updaten",
    'form.button.finish': "Afronden",
    'form.button.search': "Zoeken",
    'form.button.end': "Einde",
    'form.search.no_matches': "Geen overeenkomstige resultaten gevonden",
    'form.confirm_email': "Bevestig e-mailadres",
    'form.confirm_pass_word': "Bevestig wachtwoord",
    'form.required_fields': "Verplichte velden",
    'form.nothing_selected': "Niets geselecteerd",
    'form.confirm_field': "Bevestig %{formFieldLabel}",
    'form.choice.n/a': "N.v.t.",
    'form.choice.yes': "Ja",
    'form.choice.no': "Nee",
    'form.choice.blank_for_all': "Laat leeg of selecteer alles",
    'form.choices.select_all': "Selecteer alles",
    'form.choices.deselect_all': "Deselecteer alles",
    'form.field.private': "Privéveld",

    // USER ERRORS
    'user.error.dup_email': "Er heeft zich al een gebruiker geregistreerd met het opgegeven e-mailadres. <In plaats hiervan inloggen?>",
    'user.error.dup_sms': "Een andere gebruiker heeft dit mobiele telefoonnummer al geregistreerd ",
  }
})
